import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@wartek-id/tabs'
import { Text } from '@wartek-id/text'

import { RQStatus, SatDikDetail, SatpenPtkSummaryResponse } from '@/apis/types'

import { DataSource } from './DataSource'
import { TabDocPerijinan } from './TabDocPerijinan'
import { TabIdentitas } from './TabIdentitas'
import { TabKontak } from './TabKontak'
import { TabMap } from './TabMap'
import { TabPanelLoader } from './TabPanelLoader'
import { TabRekapitulasi } from './TabRekapitulasi'
import { TabSaranaPrasarana } from './TabSaranaPrasarana'

export function SatdikDetailContent({
  status,
  masterData,
  lastUpdatedAt,
  withHeader = false,
  ptkSummary,
  withPtkSummary = false,
}: {
  status: RQStatus
  masterData?: SatDikDetail
  ptkSummary?: SatpenPtkSummaryResponse
  lastUpdatedAt?: string
  withHeader?: boolean
  withPtkSummary?: boolean
}) {
  return (
    <>
      <div>
        {withHeader && (
          <header
            className="rounded-t border-b bg-surface-subdued"
            style={{
              padding: '16px 20px',
            }}
          >
            <Text variant="heading-sm">
              {masterData?.nama || 'Detail Satuan Pendidikan'}
            </Text>
          </header>
        )}
        <section className="px-4 pb-4">
          <Tabs defaultIndex={0}>
            <TabList withBorder>
              <Tab data-testid="tab-identity">Identitas</Tab>
              <Tab data-testid="tab-licensing">Dokumen dan Perijinan</Tab>
              {withPtkSummary && (
                <Tab data-testid="tab-rekapitulasi">Rekapitulasi</Tab>
              )}
              <Tab data-testid="tab-tools">Sarana dan Prasarana</Tab>
              <Tab data-testid="tab-contact">Kontak</Tab>
              <Tab data-testid="tab-map">Peta</Tab>
            </TabList>
            <TabPanels className="mt-4">
              <TabPanel>
                <TabPanelLoader
                  status={status}
                  masterData={masterData}
                  rows={8}
                  Panel={TabIdentitas}
                />
              </TabPanel>
              <TabPanel>
                <TabPanelLoader
                  status={status}
                  masterData={masterData}
                  rows={9}
                  Panel={TabDocPerijinan}
                />
              </TabPanel>
              {withPtkSummary && ptkSummary && (
                <TabPanel>
                  <TabRekapitulasi ptkSummary={ptkSummary} />
                </TabPanel>
              )}
              <TabPanel>
                <TabPanelLoader
                  status={status}
                  masterData={masterData}
                  rows={3}
                  Panel={TabSaranaPrasarana}
                />
              </TabPanel>
              <TabPanel>
                <TabPanelLoader
                  status={status}
                  masterData={masterData}
                  rows={4}
                  Panel={TabKontak}
                />
              </TabPanel>
              <TabPanel>
                <TabPanelLoader
                  status={status}
                  masterData={masterData}
                  rows={5}
                  Panel={TabMap}
                />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </section>
        <DataSource lastUpdatedAt={lastUpdatedAt} />
      </div>
    </>
  )
}
